import { SectionWrapper } from '../components/SectionWrapper';

import styles from './KuduRoleSection.module.css';

export function KuduRoleSection() {
  return (
    <SectionWrapper background="white" data-testid="research-section-kudu-role">
      <div className={styles.section}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>KUDU&apos;S ROLE, IN PLAIN LANGUAGE</p>
          <h2 className={styles.title}>Kudu is the platform. The research is independent.</h2>
          <p>
            Kudu provided the course platform on which AIMS was deployed. The
            AI-generated hints were delivered through Kudu. The supplemental
            math assignments were administered via Kudu. Student usage data
            came from Kudu.
          </p>
          <p>
            The research itself is independent: designed, conducted, analyzed,
            and published by researchers at UCLA&apos;s Center for Education
            Innovation and Learning in the Sciences and UC San Diego. Funding
            came from UCLA&apos;s Teaching and Learning Center.
          </p>
          <p>
            What that distinction matters for: when you read claims about
            Kudu&apos;s AI improving learning outcomes, those claims rest on
            peer-reviewed work that wasn&apos;t authored, sponsored, or paid
            for by us. We helped build the tools, but we didn&apos;t grade the
            homework.
          </p>
          <aside className={styles.disclosure}>
            <strong>Disclosure:</strong> Kudu was conceived by Alexander
            Kusenko, Professor of Physics & Astronomy at UCLA, who is also a
            co-author on the AIMS publication. The other authors have no
            financial interest in Kudu. The lead author and funding sources are
            noted in the published paper.
          </aside>
        </div>

        <figure className={styles.mockup}>
          <div className={styles.browserBar} aria-hidden="true">
            <span />
            <span />
            <span />
            <div>kudu.com/course/physics-1/homework/ch4-q3</div>
          </div>
          <div className={styles.problem}>
            <p className={styles.problemTitle}>Problem 4.3</p>
            <p>
              A block of mass 5 kg slides down a frictionless incline of angle
              30°. Find the acceleration.
            </p>
            <div className={styles.hintPanel}>
              <p className={styles.hintBadge}>KAI Hint</p>
              <p className={styles.hintTitle}>Let&apos;s break this down step by step.</p>
              <ol>
                <li>Identify the forces acting on the block.</li>
                <li>Resolve gravity along and perpendicular to the incline.</li>
                <li>Use Newton&apos;s second law along the slope.</li>
              </ol>
            </div>
          </div>
          <figcaption>
            A Kudu AI hint, as it appeared to students in the AIMS study. Hints
            guide reasoning rather than providing solutions.
          </figcaption>
        </figure>
      </div>
    </SectionWrapper>
  );
}
